// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"41":"wordlist-5","648":"wordlist-4","850":"wordlist-6"}[chunkId] + ".js";
};